<template>
    <img :src="svg">
</template>

<script>
export default {
  props: {
    svg: String,
  },
}
</script>
